export const propsTs = {
  
    position: 'top-right',
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: 'colored',
    progress: undefined,
};

export const getInitialColumns = (key, defaultColumns) => {
    const savedColumns = localStorage.getItem(key);
    if (savedColumns) {
      return JSON.parse(savedColumns);
    }
    localStorage.setItem(key, JSON.stringify(defaultColumns));
    return defaultColumns;
  };